export function getFirstValidUrlEntry(candidateEntries = []) {
  for (const entry of candidateEntries) {
    const value = String(entry?.value || "").trim();
    if (!value) continue;

    try {
      const parsed = new URL(value);
      if (parsed.protocol === "http:" || parsed.protocol === "https:") {
        return {
          label: String(entry?.label || "Report Link").trim() || "Report Link",
          value,
        };
      }
    } catch (_error) {
      // Ignore invalid URL candidates and continue.
    }
  }

  return null;
}

export function normalizeAnalyticsEmbedUrl(originalUrl) {
  const cleanedUrl = String(originalUrl || "").trim();
  if (!cleanedUrl) {
    return {
      embedUrl: "",
      embedMode: "unavailable",
      normalized: false,
    };
  }

  try {
    const parsed = new URL(cleanedUrl);
    const host = parsed.hostname.toLowerCase();
    const path = parsed.pathname || "";
    const isLookerHost =
      host.includes("lookerstudio.google.com") || host.includes("datastudio.google.com");

    if (!isLookerHost) {
      return {
        embedUrl: cleanedUrl,
        embedMode: "external",
        normalized: false,
      };
    }

    if (path.includes("/embed/")) {
      return {
        embedUrl: parsed.toString(),
        embedMode: "looker_embed",
        normalized: false,
      };
    }

    const reportingIndex = path.indexOf("/reporting/");
    if (reportingIndex >= 0) {
      parsed.pathname = `${path.slice(0, reportingIndex)}/embed${path.slice(reportingIndex)}`;
      return {
        embedUrl: parsed.toString(),
        embedMode: "looker_embed",
        normalized: true,
      };
    }

    parsed.searchParams.set("rm", "embed");
    return {
      embedUrl: parsed.toString(),
      embedMode: "looker_embed",
      normalized: true,
    };
  } catch (_error) {
    return {
      embedUrl: cleanedUrl,
      embedMode: "external",
      normalized: false,
    };
  }
}

export function resolveAnalyticsReportSurface(surface = null) {
  const openUrlCandidate = getFirstValidUrlEntry([
    { label: "Open URL", value: surface?.openUrl },
    { label: "Report URL", value: surface?.reportUrl },
    { label: "URL", value: surface?.url },
    { label: "Embed URL", value: surface?.embedUrl },
  ]);
  const openUrl = openUrlCandidate?.value || "";
  const normalized = normalizeAnalyticsEmbedUrl(surface?.embedUrl || openUrl);

  return {
    ...(surface || {}),
    available: Boolean(openUrl),
    openUrl,
    embedUrl: normalized.embedUrl || "",
    embedMode: normalized.embedMode,
    normalized: normalized.normalized,
  };
}
